/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {DefaultLightboxAdapter as ɵb,ngxPhotoSwipeFactory as ɵa} from './lib/adpters/lightbox-adapter';
export {LightboxComponent as ɵc} from './lib/components/lightbox/lightbox.component';
export {NgxPhotoswipeService as ɵd} from './lib/services/ngx-photoswipe.service';